import React from 'react';
import ProductItem from './ProductItem';

function ProductList({ wines, onWineClick }) {

  return (
    <div className="product-list">
      {wines.map(wine => (
        <ProductItem 
          key={wine.name + wine.year + wine.type.value + wine.size.value}  
          wine={wine} 
          onClick={() => onWineClick(wine)} 
        />
      ))}
    </div>
  );
}

export default ProductList;

